import React from 'react';
import { ArrowRight, Award, TrendingUp, Users } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 via-white to-blue-50 overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
      <div className="absolute top-40 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in-up">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold">
                Outdoor, Transit & Digital Advertising in Solapur
              </span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              <span className="text-blue-600">Advertising Agency in Solapur</span>
              <br />
              <span className="text-3xl md:text-4xl font-semibold text-gray-700 mt-2 block">
                {companyInfo.name}: {companyInfo.tagline}
              </span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {companyInfo.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToContact}
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-6 group"
              >
                Connect With Us
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={scrollToServices}
                size="lg"
                variant="outline"
                className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 text-lg px-8 py-6"
              >
                Explore Services
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div className="text-center sm:text-left">
                <div className="text-3xl font-bold text-blue-600">{companyInfo.experience}</div>
                <div className="text-sm text-gray-600 mt-1">Excellence</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-3xl font-bold text-blue-600">{companyInfo.campaigns}</div>
                <div className="text-sm text-gray-600 mt-1">Campaigns</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="text-3xl font-bold text-blue-600">{companyInfo.services}</div>
                <div className="text-sm text-gray-600 mt-1">Services</div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative animate-fade-in">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_insmart-media/artifacts/ttltqjbu_In%20smart%20Media%20New%20Logo.jpeg"
                alt="IN SMART MEDIA - Your Complete Advertising Hub"
                width="800"
                height="600"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Floating Badge */}
            {/* <div className="absolute z-10 -top-6 -right-16 bg-blue-600 text-white rounded-2xl p-6 shadow-xl animate-float display-hidden lg:block">
              <Users size={32} className="mb-2" />
              <div className="text-2xl font-bold">All Types</div>
              <div className="text-sm">Business Solutions</div>
            </div> */}
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out;
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        
        .animate-blob {
          animation: blob 7s infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};
